import { useMemo } from 'react';

import { getUserData } from 'store/selectors/general';
import useMemoSelector from 'hooks/useMemoSelector';

type UseAuthInfoReturnType ={
  isProOrGoldUser?: boolean;
  isAuthorized?: boolean;
}

// pro and gold_old tiers are the same
// for users who subscribed before the introduction of the Pro tier, we receive gold_old
const proSubscriptions = ['gold_old', 'pro'];

function useAuthInfo(): UseAuthInfoReturnType {
  const { isAuthorized, isSubscribed, subscriptionType } = useMemoSelector(getUserData);

  const isProOrGoldUser = useMemo(() => (
    Boolean(subscriptionType) && isSubscribed && proSubscriptions.includes(subscriptionType as string)
  ), [subscriptionType, isSubscribed]);

  return {
    isProOrGoldUser,
    isAuthorized,
  };
}

export default useAuthInfo;
